import { lazy } from 'react';

export const CalculationMtrs = lazy(() =>
    import('./UerCalculationMtrs').then((module) => ({ default: module.CalculationMtrs })),
);
